import type { Widget } from "https://storage.googleapis.com/speechify-api-cdn/speechifyapi.min.mjs";
import type { FunctionComponent } from "react";
import { useEffect, useRef, useState } from "react";

import { SpeechSkipClassName } from "~/components/article/article-speech/consts";
import { ZIndexLayer } from "~/lib/styles";
type Props = {
  articleElementReference: HTMLElement | null;
};

export const ArticleSpeechPlayer: FunctionComponent<Props> = ({ articleElementReference }) => {
  const reference = useRef<HTMLDivElement>(null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (!reference.current || !articleElementReference || isMounted) return;
    let widget: Widget;

    const run = async () => {
      const speechifyWidget = await import(
        /* webpackIgnore: true */ "https://storage.googleapis.com/speechify-api-cdn/speechifyapi.min.mjs"
      );
      widget = speechifyWidget.makeSpeechifyExperience({
        customStyles: {
          widget: {
            zIndex: `${ZIndexLayer.Drawer - 1}`,
          },
        },
        ignoreElements(element) {
          return (
            element.tagName === "NOSCRIPT" ||
            element.tagName === "STYLE" ||
            element.tagName === "SCRIPT" ||
            element.classList.contains(SpeechSkipClassName)
          );
        },
        inlinePlayerElement: reference.current,
        paragraphSettings: {
          isEnabled: "while-playing",
          marginRight: "-10px",
        },
        rootElement: articleElementReference,
      });
      await widget.mount();
    };
    setIsMounted(true);
    void run();

    return () => {
      void widget?.unmount?.();
    };
  }, [reference, articleElementReference, isMounted]);

  return <div ref={reference} />;
};
